<template>
  <div class="news-push">
    <div class="status-body">
      <!-- 筛选条件 -->
      <div class="filter-condition">
        <div class="box-left">
          <div class="left_top">
            <span>操作时间:</span>
            <div class="filterHospitalTitle" style="display: inline-block">
              <el-date-picker
                v-model="filter_date"
                type="daterange"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                clearable
                unlink-panels
                :default-value="timeDefaultShow"
                @change="dataTimeChangeAction"
                style="width: 250px"
              ></el-date-picker>
            </div>
            <span style="margin-left: 18px">推送时间:</span>
            <div class="filterHospitalTitle" style="display: inline-block">
              <el-select
                v-model="queryParams.ruleType"
                placeholder="请选择推送时间"
                @change="onSubmit"
                clearable
              >
                <el-option
                  v-for="item in typelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="left_bottom">
            <el-button class="filter-button" type="primary" @click="addNewRule(false)">
              新建规则
            </el-button>
            <!-- <el-row>
              <el-col :span="12">
                <div class="right">
                  <el-button class="filter-button" type="primary" @click="onSubmit">筛选</el-button>
                  <el-button class="filter-button" plain @click="reset">重置</el-button>
                </div>
              </el-col>
            </el-row> -->
          </div>
        </div>
      </div>
      <!-- 表格区域 -->
      <div class="table-conter">
        <!-- 列表 -->
        <div class="table-list">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            stripe
            :header-cell-style="{
              background: '#fff',
              color: '#303133',
              fontWeight: '100',
              height: '60px',
            }"
          >
            <template slot="empty">
              <div class="table-noData">
                <img
                  class="table-noData-img"
                  src="https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png"
                />
                <div class="table-noData-word">暂无相关内容</div>
              </div>
            </template>
            <el-table-column prop="id" label="规则ID" min-width="8%"></el-table-column>
            <el-table-column prop="ruleName" label="规则名称" min-width="10%"></el-table-column>
            <el-table-column prop="articleTitle" label="推送内容" min-width="20%">
              <template slot-scope="scope">
                <div class="article-content">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.articleCoverListUrl"
                    fit="contain"
                  ></el-image>
                  <div class="content-right">
                    <el-tooltip placement="top" effect="light">
                      <div slot="content">{{ scope.row.articleTitle }}</div>
                      <span class="articleTitle">{{ scope.row.articleTitle }}</span>
                    </el-tooltip>
                    <span>ID:{{ scope.row.articleId }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="推送时间" min-width="15%">
              <template slot-scope="scope">入职第{{ scope.row.ruleType }}天</template>
            </el-table-column>
            <el-table-column prop="updateBy" label="操作人" min-width="10%"></el-table-column>
            <el-table-column prop="creatTime" label="创建时间" min-width="15%"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" min-width="15%"></el-table-column>
            <el-table-column label="操作" min-width="20%">
              <template slot-scope="scope">
                <div style="display: flex">
                  <!-- 待审核事件 -->
                  <el-button
                    type="text"
                    style="font-size: 16px; margin-left: 10px"
                    @click="addNewRule(scope.row.id)"
                  >
                    编辑
                  </el-button>
                  <el-button
                    type="text"
                    @click="deleteRoule(scope.row)"
                    style="font-size: 16px; margin-left: 10px"
                  >
                    删除
                  </el-button>
                  <el-button
                    type="text"
                    @click="pushnameList(scope.row)"
                    style="font-size: 16px; margin-left: 10px"
                  >
                    推送名单
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.page_index"
            :page-size="queryParams.page_size"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalVal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 删除规则 -->
    <Dialog
      title="删除规则"
      :visible="dialogVisibleArray.deleteVisible"
      width="400px"
      @submitPopupData="delAction"
      @resetPopupData="delCloseDialog"
      @handleClose="delCloseDialog"
      button-type="danger"
    >
      <template slot>
        <span style="margin-left: 30px">是否确认删除规则？</span>
      </template>
    </Dialog>
    <!-- 推送名单 -->
    <Dialog
      class="pushNameDialog"
      :title="dialogTitle"
      :visible="guidelinesVisible"
      width="600px"
      :show-dialog-footer="false"
      @handleClose="guidelinesCloseDialog"
    >
      <template slot>
        <nameList :name="sheetName" :typeval="typeVal" :parameter="parameterObj" ref="nameList" />
      </template>
    </Dialog>
  </div>
</template>
<script>
//  引用 table静态资源
import Dialog from '../../../../components/dialog/index';
import nameList from '../../component/nameList/index';
import { mapGetters } from 'vuex';
import { QueryPublishRuleList, DeletePublishRule } from '../../../../api/pointsRule';
const { tableData, dialogVisibleArray } = require('./index');
export default {
  name: 'EmployeeMaintenance',
  components: {
    Dialog, // 弹窗组件
    nameList,
  },
  data() {
    return {
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      filter_date: [], //  更新时间
      timeDefaultShow: '', // 默认显示时间
      tableData, // 表格数据
      totalVal: 1, // 数据总条数
      tableLoading: false, // 是否展示加载状态
      typeVal: false,
      sheetName: '',
      dialogTitle: '推送名单',
      queryParams: {
        page_index: 1, // 当前页数
        page_size: 10, // 每页条数
        ruleType: '', // 规则类型
        startTime: '', // 更新开始时间
        endTime: '', // 更新结束时间
      }, // 列表接口请求参数
      delId: '', // 删除id
      dialogVisibleArray, // 控制弹窗是否展示
      guidelinesVisible: false, // 入职推送名单弹窗
      parameterObj: {}, // 预演推送人员名单请求参数
    };
  },
  computed: {
    ...mapGetters('huizhi/user', {
      typelist: 'getTypeList',
    }),
  },
  created() {
    this.getList();
    this.dataTime();
  },
  methods: {
    // 设置日期选择默认为上月及当月
    dataTime() {
      this.timeDefaultShow = new Date();
      this.timeDefaultShow.setMonth(new Date().getMonth() - 1);
    },
    // 更新时间选择事件
    dataTimeChangeAction() {
      if (Array.isArray(this.filter_date)) {
        const startTime = this.filter_date[0];
        const endTime = this.filter_date[1];
        this.queryParams.startTime = `${startTime} 00:00:00`;
        this.queryParams.endTime = `${endTime} 23:59:59`;
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.onSubmit();
    },
    // 筛选按钮事件
    onSubmit() {
      this.queryParams.page_index = 1;
      this.getList();
    },
    // 重置搜索条件
    reset() {
      this.queryParams = {
        page_index: 1, // 当前页数
        page_size: 10, // 每页条数
        ruleType: '', // 规则类型
        startTime: '', // 更新开始时间
        endTime: '', // 更新结束时间
      };
      this.getList();
    },
    // 页码改变
    handleCurrentChange(page) {
      this.queryParams.page_index = page;
      this.getList(1);
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.queryParams.page_size = val;
      this.getList();
    },
    // 获取列表信息
    getList(val) {
      const page = this.queryParams.page_index;
      this.queryParams.page_index = val ? page : 1;
      this.tableLoading = true;
      QueryPublishRuleList(this.queryParams)
        .then((res) => {
          const data = res?.dataList;
          this.tableData = data;
          this.totalVal = res?.total_num;
          this.tableLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.tableLoading = false;
        });
    },
    // 确认删除
    delAction() {
      const parmas = {
        id: this.delId,
      };
      DeletePublishRule(parmas)
        .then((res) => {
          console.log(res);
          if (res.err_code === 1) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
          } else {
            this.$message({
              message: res.err_msg,
              type: 'error',
            });
          }
          this.delCloseDialog();
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 删除弹窗关闭
    delCloseDialog() {
      this.delId = '';
      this.dialogVisibleArray.deleteVisible = false;
    },
    // 点击推送名单
    pushnameList(row) {
      const parmas = {
        ruleId: row.id,
        pushDate: row?.updateTime.substring(0, 10) || '',
      };
      this.sheetName = row.ruleName;
      this.dialogTitle = `${row.ruleName}- 推送名单`;
      this.parameterObj = parmas;
      this.guidelinesVisible = true;
    },
    // 入职推送名单弹窗关闭
    guidelinesCloseDialog() {
      this.guidelinesVisible = false;
      this.$refs.nameList.resetParameters();
      this.sheetName = '';
    },
    // 新建规则/编辑规则
    addNewRule(id) {
      if (id) {
        // 前往编辑
        this.g_tourl(`/saas/huizhi/EmployeeMaintenance/edit.html?id=${id}`);
        return;
      } // 前往新建
      this.g_tourl(`/saas/huizhi/EmployeeMaintenance/edit.html`);
    },
    // 删除
    deleteRoule(row) {
      this.delId = row.id;
      this.dialogVisibleArray.deleteVisible = true;
    },
    // 删除关闭事件
    closeDialog() {
      this.dialogVisibleArray.addVisible = false;
      this.resetParmslist();
      this.$refs.ruleForm.resetFields();
    },
    // 重置编辑参数
    resetParmslist() {
      this.ruleForm = {
        id: '', // 规则ID
        agentId: '', // 企业应用ID
        articleId: '', // 企业微信文章id
        ruleType: '',
      };
    },
  },
};
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
